import React, { Component } from 'react';


import { Col, Container, Row } from "reactstrap";

// Redux
import { connect } from 'react-redux';

// actions
import { apiError, checkLogin, requestOtpUser, resetLoginActionState, resetLoginState, setCurrentUser, switchUser, verify_admin } from '../../store/actions';

// import images
import { Alert, Avatar, Box, Divider, FormControlLabel, FormHelperText, Grid, Radio, Stack } from '@mui/material';
import Logo from '../../assets/images/Logo.png';
import LogoWhite from '../../assets/images/logo-white.png';
import LoadingDialog from '../../components/Common/LoadingDialog';
import withRouter from '../../components/Common/withRouter';
import CustomButton from '../../components/Form/CustomButton';
import CustomTextField from '../../components/Form/CustomTextField';
import loginBg from '../../assets/images/login-background.jpg';
import Footer from '../../components/VerticalLayout/Footer';
import { MuiOtpInput } from 'mui-one-time-password-input';
import Label from '../../components/Common/Label';
import Helpers from '../../helpers/helpers';
import Notification from '../../components/Common/Notification';
import { Icon } from '@iconify/react/dist/iconify.js';
class Login extends Component {

    constructor(props) {
        super(props);
        this.props.resetLoginState()
        this.state = {
            // username: "superadmin@app.com",
            username: "s",
            password: "123123123",
            phone: "",
            // phone: "01522455521",
            login_type: "whatsapp",
            // phone: "87677726",
            loading: false,
            rememberMe: false,
            showPW: false,
            isPhone: true,
            isSent: false,
            isVerified: false,
            selectedAccount: null,
            notification: {
                open: false,
                msg: "",
                type: "success",
            },
            personalAccountList: [],
            dealerAccountList: [],
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        this.props.resetLoginState()
        this.setState({ loading: true });

        const values = {
            login_type: this.state.login_type,
            phone: this.state.phone,
            otp: this.state.otp
        }
        this.props.checkLogin(values, this.props.router.navigate, this.state.rememberMe);
        // this.setState({ loading: false });
    }

    handleVerifyCode() {
        this.setState({
            loading: true,
        })
        const values = {
            login_type: this.state.login_type,
            phone: '65' + this.state.phone,
            otp: this.state.otp
        }
        this.props.checkLogin(values, this.props.router.navigate, this.state.rememberMe);
    }

    handleSendCode() {
        if (!this.state.phone) {
            this.setState({ notification: { open: true, msg: "Please enter your phone number", type: "error" } });
            return;
        }
        this.setState({
            loading: true,
        });
        this.props.requestOtpUser({
            login_type: this.state.login_type, phone: this.state.phone ? '65' + this.state.phone : ''
        });
    }

    setNotification = (notification) => {
        this.setState({ notification: notification });
    }

    handleSetCurrentUser = () => {
        this.setState({ loading: true });
        let payload = {
            type: this.state.selectedAccount?.dealer_id ? 'dealer' : 'personal',
        }
        if (this.state.selectedAccount?.dealer_id) {
            payload['dealer_id'] = this.state.selectedAccount?.dealer_id;
        }
        this.props.switchUser({ data: payload });
    }

    async componentDidMount() {
        this.props.apiError("");
        document.body.classList.add("auth-body-bg");
        // if (localStorage.getItem("remember") === "true") {
        //     this.setState({ username: localStorage.getItem("username"), rememberMe: true });
        // }
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.loginError && this.props.loginError) {
                this.setState({ loading: false });
            }
            if (this.props.requestOtp && this.props.requestOtp?.code === "success") {
                this.setState({ loading: false, isSent: true, notification: { open: true, msg: this.props?.requestOtp?.message, type: "success" } });
                this.props.resetLoginActionState();
            }
            if (this.props.loginRes && this.props.loginRes?.code === "success") {
                this.props.resetLoginState();
                this.props.verify_admin();
                this.setState({ loading: false, isSent: false, isVerified: true, });
            }
            if (this.props.switchUserRes && this.props.switchUserRes?.user?.code === "success") {
                this.setState({ loading: false, });
                localStorage.setItem('selected_account_id', this.state.selectedAccount?.id);
                this.props.router.navigate('/dashboard');
            }
            // if (this.props.verifyAdmin && !this.state.personalAccountList && !this.state.dealerAccountList) {
            //     this.setState({
            //         dealerAccountList: this.props?.verifyAdmin?.user?.data?.profile?.active_dealer_users,
            //         personalAccountList: this.props?.verifyAdmin?.user?.data?.profile,
            //     });

            // }
        }
    }

    filterBodyList = [
        {
            id: "whatsapp",
            name: "WhatsApp"
        },
        {
            id: "sms",
            name: "SMS"
        }
    ]


    render() {
        return (
            <React.Fragment>
                <div style={{ backgroundColor: '#F1F5F7', height: '100vh', fontSynthesis: 'none' }}>
                    <LoadingDialog open={this.state.loading} />
                    <Notification notification={this.state.notification} setNotification={this.setNotification} />
                    <Container fluid className="p-0">
                        <Grid container>
                            <Grid item md={6} sm={12} xs={12} style={{ backgroundColor: 'white', position: 'relative' }}>
                                <div style={{ height: '100vh' }} className={this.props.currentWidth <= 768 ? '' : 'd-flex align-items-center justify-content-center'}>
                                    {
                                        this.state.isSent ?
                                            <>
                                                {
                                                    this.props?.currentWidth <= 768 &&
                                                    <div style={{ textAlign: 'center', paddingBlock: 50 }}>
                                                        <img src={Logo} alt="Logo" style={{ height: 32, width: 91, objectFit: 'contain' }} />
                                                    </div>
                                                }
                                                <Box sx={{ minWidth: '50%', border: this.props?.currentWidth <= 768 ? '1px solid #E3E8EE' : 'none', borderRadius: 5 }} p={this.props?.currentWidth <= 768 ? 4 : 10} py={this.props?.currentWidth <= 768 && 5} m={this.props?.currentWidth <= 768 && 5}>
                                                    <div className='text-bold font-size-24'>Verify your phone number</div>
                                                    <div className='subheader-2' style={{ maxWidth: 350 }}>
                                                        Please enter the 6-digit code we just sent over {this.state.login_type === 'sms' ? 'SMS' : 'WhatsApp'} to +65{this.state.phone}
                                                    </div>
                                                    <div className='subheader-2 mt-3'>
                                                        Not the right number?
                                                        <span className='clickable-link mx-1' style={{ color: '#D13536' }} onClick={() => { this.setState({ isSent: false, phone: '' }) }}>Change number</span>
                                                    </div>
                                                    {this.props.loginError && this.props.loginError?.errors?.otp?.[0] ? <Alert severity="error" className='my-3'>{this.props.loginError?.errors?.otp?.[0]}</Alert> : null}
                                                    <div className={`d-flex justify-content-center ${this.props.loginError?.errors?.otp?.[0] ? 'mb-5' : 'my-5'}`} style={{ maxWidth: this.props?.currentWidth <= 425 ? '100%' : '88%', justifySelf: 'center' }}>
                                                        <MuiOtpInput
                                                            value={this.state.otp}
                                                            length={6}
                                                            gap={this.props?.currentWidth <= 425 ? 1 : this.props.currentWidth <= 768 ? 2 : 2}
                                                            onChange={(e) => this.setState({ otp: e })}
                                                            alignContent={'center'}
                                                            justifyContent={'center'}
                                                        />
                                                    </div>
                                                    <div className='d-flex justify-content-center'>
                                                        Didn’t get the code? <span className='link-text text-bold mx-1' onClick={() => this.handleSendCode()}>Resend code</span>
                                                    </div>
                                                    <div className='d-flex justify-content-center my-4 subheader-2' style={{ flexWrap: 'wrap', flexDirection: 'row', justifySelf: 'center' }}>
                                                        By logging in, you acknowledge and agree to iAuto’s {' '}
                                                        <div className='link-text text-bold' style={{ color: '#D13536', marginInline: 5 }}>Terms of Use</div>
                                                        and <span className='link-text text-bold' style={{ color: '#D13536', marginLeft: 5 }}>Privacy Policy</span>.
                                                    </div>
                                                    <div className="mt-4 text-center">
                                                        <CustomButton
                                                            title={'Next'}
                                                            width={'100%'}
                                                            padding={25}
                                                            press={() => this.handleVerifyCode()}
                                                        />
                                                    </div>
                                                </Box>
                                            </>
                                            :
                                            this.state.isVerified ? <>
                                                {
                                                    this.props?.currentWidth <= 768 &&
                                                    <div style={{ textAlign: 'center', paddingBlock: 50 }}>
                                                        <img src={Logo} alt="Logo" style={{ height: 32, width: 91, objectFit: 'contain' }} />
                                                    </div>
                                                }
                                                <Box sx={{ minWidth: '50%', height: '80%' }} p={this.props?.currentWidth <= 768 ? 3 : 2} py={this.props?.currentWidth <= 768 && 5} m={this.props?.currentWidth <= 768 && 3}>
                                                    <div className='text-bold font-size-24'>Select account to continue</div>
                                                    <div className='subheader-2' style={{ maxWidth: 350 }}>
                                                        Please select the profile you’d like to manage today.
                                                    </div>
                                                    <div style={{ overflow: 'auto', height: 'inherit' }}>
                                                        {
                                                            // this.state.personalAccountList?.length > 0 &&
                                                            this.props?.verifyAdmin?.user?.data?.profile &&
                                                            <div className='mt-3'>
                                                                <div className='text-bold mt-5 mb-2'>Personal Account</div>
                                                                {
                                                                    // this.state.personalAccountList?.length > 0 && this.state.personalAccountList.map((item, index) => (
                                                                    this.props?.verifyAdmin?.user?.data?.profile &&
                                                                    <div className={`${this.state.selectedAccount === this.props?.verifyAdmin?.user?.data?.profile.id ? 'selected-user-container' : 'user-container'} clickable`} onClick={() => this.setState({ selectedAccount: this.props?.verifyAdmin?.user?.data?.profile.id })}>
                                                                        <Grid container className='d-flex align-items-center' spacing={2}>
                                                                            <Grid item lg={2} md={2} sm={2} xs={2} ><Avatar src={this.props?.verifyAdmin?.user?.data?.profile?.profile_photo_path} style={{ width: 36, height: 36 }} /></Grid>
                                                                            <Grid item lg={8} md={8} sm={8} xs={8}>
                                                                                <div className='d-flex align-items-center'>
                                                                                    <div>{this.props?.verifyAdmin?.user?.data?.profile.name}</div>
                                                                                    <Label.GeneralStatusLabel label={'verified'} list={Helpers.userType} borderRadius={'30px'} />
                                                                                </div>
                                                                                <div className='subheader-2'>{this.props?.verifyAdmin?.user?.data?.profile?.phone || '-'}</div>
                                                                            </Grid>
                                                                            <Grid item lg={2} md={2} sm={2} xs={2} className='d-flex justify-content-end'>
                                                                                <FormControlLabel
                                                                                    checked={this.state.selectedAccount === this.props?.verifyAdmin?.user?.data?.profile.id}
                                                                                    value={this.state.selectedAccount === this.props?.verifyAdmin?.user?.data?.profile.id}
                                                                                    onClick={() => this.setState({ selectedAccount: this.props?.verifyAdmin?.user?.data?.profile.id })}
                                                                                    // key={index}
                                                                                    style={{ fontFamily: 'FunnelSans', fontSize: 14, margin: 0 }}
                                                                                    control={<Radio
                                                                                        sx={{
                                                                                            '&.Mui-checked': {
                                                                                                color: "#1D1B1B",
                                                                                            },
                                                                                            '& .MuiSvgIcon-root': {
                                                                                                fontSize: 20,
                                                                                            },

                                                                                        }} />}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                    // ))
                                                                }
                                                            </div>
                                                        }

                                                        {
                                                            this.props?.verifyAdmin?.user?.data?.profile?.active_dealer_users &&
                                                            // this.state.dealerAccountList?.length > 0 &&
                                                            <div className='mt-3'>
                                                                <div className='text-bold mt-5 mb-2'>Dealer Accounts</div>
                                                                {
                                                                    // this.state.dealerAccountList?.length > 0 && this.state.dealerAccountList.map((item, index) => (
                                                                    this.props?.verifyAdmin?.user?.data?.profile?.active_dealer_users && this.props?.verifyAdmin.user.data.profile.active_dealer_users.map((dealer, idx) => {
                                                                        return (
                                                                            <div className={`mt-3 ${dealer?.dealer_status === "active" ? 'clickable' : ''} ${this.state.selectedAccount?.id === dealer.id ? 'selected-user-container' : 'user-container '}`} onClick={() => { dealer?.dealer_status === "active" && this.setState({ selectedAccount: dealer }) }}>
                                                                                <Grid container className='d-flex align-items-center' spacing={2}>
                                                                                    <Grid item lg={2} md={2} sm={2} xs={2} ><Avatar src={dealer?.thumbnail} style={{ width: 36, height: 36 }} /></Grid>
                                                                                    <Grid item lg={8} md={8} sm={8} xs={8}>
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div>{dealer.company_name || '-'}</div>
                                                                                            <Label.GeneralStatusLabel label={'dealer'} list={Helpers.userType} borderRadius={'30px'} />
                                                                                        </div>
                                                                                        <div className='subheader-2'>{dealer.dealer_type || 'Member'}</div>
                                                                                        {dealer?.dealer_status !== "active" && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}>{"Dealer access pending admin approval"}</FormHelperText>}
                                                                                    </Grid>
                                                                                    <Grid item lg={2} md={2} sm={2} xs={2} sx={{ display: 'flex', justifyContent: 'end' }}>
                                                                                        <FormControlLabel
                                                                                            checked={this.state.selectedAccount?.id === dealer.id}
                                                                                            value={this.state.selectedAccount?.id === dealer.id}
                                                                                            onClick={() => dealer?.dealer_status === "active" && this.setState({ selectedAccount: dealer })}
                                                                                            // key={index}
                                                                                            disabled={dealer?.dealer_status !== "active"}
                                                                                            style={{ fontFamily: 'FunnelSans', fontSize: 14, margin: 0 }}
                                                                                            control={<Radio
                                                                                                sx={{
                                                                                                    '&.Mui-checked': {
                                                                                                        color: "#1D1B1B",
                                                                                                    },
                                                                                                    '& .MuiSvgIcon-root': {
                                                                                                        fontSize: 20,
                                                                                                    },

                                                                                                }} />}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    // ))
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="mt-4 text-center">
                                                        <CustomButton
                                                            title={'Next'}
                                                            width={'100%'}
                                                            padding={25}
                                                            press={() => this.handleSetCurrentUser()}
                                                            disabled={!this.state.selectedAccount}
                                                        />
                                                    </div>
                                                </Box></>
                                                :
                                                <>
                                                    {
                                                        this.props?.currentWidth <= 768 &&
                                                        <div style={{ textAlign: 'center', paddingBlock: 50 }}>
                                                            <img src={Logo} alt="Logo" style={{ height: 32, width: 91, objectFit: 'contain' }} />
                                                        </div>
                                                    }
                                                    <Box sx={{ minWidth: '65%', border: this.props?.currentWidth <= 768 ? '1px solid #E3E8EE' : 'none', borderRadius: 5 }} p={this.props?.currentWidth <= 768 ? 4 : 2} py={this.props?.currentWidth <= 768 && 6} m={this.props?.currentWidth <= 768 && 5}>
                                                        <div className={`text-bold font-size-24 ${this.props?.currentWidth <= 768 ? 'mb-4' : 'mb-2'}`}>Log in to your account</div>
                                                        {this.props?.loginError && this.props?.loginError?.errors ? <Alert severity="error" className='my-2'>{this.props?.loginError?.errors?.phone?.[0]}</Alert> : null}
                                                        <CustomTextField
                                                            values={this.state.phone}
                                                            variant="standard"
                                                            error={this.props.message?.errors?.username}
                                                            title={'Phone Number'}
                                                            onChange={(e) => this.setState({ phone: e })}
                                                            style={{ backgroundColor: 'white' }}
                                                            type={'phone'}
                                                            // placeholder='Phone Number'
                                                            InputProps={{
                                                                startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                                                            }}
                                                        />
                                                        {this.state?.isPhone && <Box mt={2}>
                                                            <div className="text-semibold">Receive  OTP through</div>
                                                            <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                                                                {this?.filterBodyList?.length > 0 ? this?.filterBodyList?.map((item, index) => (
                                                                    <div className={this.state.login_type?.includes(item?.id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => this.setState({ login_type: item?.id })}>
                                                                        {item?.name}
                                                                    </div>
                                                                )) : <div className="subheader-2">No Data Available</div>}
                                                            </Stack>
                                                            {this.props.codeSent?.errors?.login_type && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{this.props.codeSent?.errors?.login_type || ""}</FormHelperText>}
                                                        </Box>}
                                                        <div className="mt-4 text-center" style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                                            <CustomButton
                                                                title={'Send code'}
                                                                width={'100%'}
                                                                padding={25}
                                                                press={() => this.handleSendCode()}
                                                            />
                                                            <CustomButton
                                                                title={' Back to Home Page'}
                                                                width={'100%'}
                                                                padding={25}
                                                                backgroundColor={'transparent'}
                                                                textColor={'#000000'}
                                                                borderStyle={'1px solid #000000'}
                                                                // press={() => window.location.href = "https://mpstaging.iauto.sg/"} //staging
                                                                press={() => window.location.href = "https://www.iauto.sg/"} //production
                                                            />
                                                        </div>
                                                        <div className='d-flex align-items-center mt-4'>
                                                            <div style={{ borderTop: '1px solid #E6E6E6', flex: 1 }} />
                                                            <div className='mx-2'>OR</div>
                                                            <div style={{ borderTop: '1px solid #E6E6E6', flex: 1 }} />
                                                        </div>
                                                        <div className='d-flex mt-3 justify-content-center' >
                                                            Don't have an account?
                                                            <span className='clickable-link mx-1' style={{ color: '#B48A3C' }} onClick={() => { this.props.router.navigate('/register') }}>
                                                                Register as dealer now
                                                            </span>
                                                        </div>
                                                    </Box>
                                                </>
                                    }
                                </div>
                                {
                                    this.props.currentWidth > 768 &&
                                    <Box className='d-flex position-absolute bottom-0 justify-content-between w-100 subheader-2'>
                                        <Grid container sx={{ padding: 2 }}>
                                            <Grid item sm={6} className="d-flex">
                                                <div className="me-3">Terms of Use</div>
                                                <div>Privacy Policy</div>
                                            </Grid>
                                            <Grid item sm={6} className="text-end d-flex justify-content-end">
                                                {new Date().getFullYear()} &copy; iAuto All Rights Reserved.
                                            </Grid>
                                        </Grid>
                                    </Box>
                                }
                            </Grid>
                            {
                                this.props?.currentWidth > 768 &&
                                <Grid item md={6} sm={0} xs={0} sx={{ position: 'relative' }}>
                                    <img src={loginBg} style={{ objectFit: 'cover', height: '100vh', width: '100%', position: 'relative' }} />
                                    <div className="position-absolute top-0 left-0  p-5" >
                                        <img src={LogoWhite} alt="" height="36" width={91} />
                                    </div>
                                    <div className='position-absolute bottom-0 left-0 p-5' style={{ color: 'white' }}>
                                        <div className='font-size-24 text-semibold'>
                                            Buy. Sell. Ride. All on iAuto.
                                        </div>
                                        <div >
                                            Sign in to browse, buy, or become a seller on iAuto.
                                        </div>
                                    </div>
                                </Grid>
                            }

                        </Grid>
                    </Container>
                </div>
            </React.Fragment >
        );
    }
}

const mapStatetoProps = state => {
    const { loginError, requestOtp, loginRes, verifyAdmin, switchUserRes } = state.Login;
    const { currentWidth } = state.Layout;

    return { loginError, requestOtp, loginRes, currentWidth, verifyAdmin, switchUserRes };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, requestOtpUser, apiError, resetLoginState, resetLoginActionState, setCurrentUser, verify_admin, switchUser })(Login));